<template>
    <div class="venu-related-post">
        <WpLink v-if="post" :url="post.link" class="inner">
            <div class="heading-venue-block font--400 jost">
                <h3 class="tit jost--30">{{post.title}}</h3>
                <div class="category jost--25" v-if="post.type === 'venu' && post.acf && post.acf.category">
                    {{post.acf.category.name}}
                </div>
            </div>
            <svg width="50" height="50" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><g fill-rule="evenodd"><path class="circle" d="M24.999 0h.002q.614 0 1.227.03.613.03 1.223.09.611.06 1.218.15t1.21.21q.601.12 1.196.27.596.148 1.183.326.587.179 1.165.385.578.207 1.145.442.567.235 1.121.497.555.263 1.096.552.542.29 1.068.605t1.037.656q.51.341 1.003.707.493.365.967.755.475.389.93.801.454.412.888.846t.846.889q.412.454.801.929.39.474.755.967.366.493.707 1.003.34.51.656 1.037.316.526.605 1.068.29.54.552 1.095.262.555.497 1.122.235.567.442 1.145.206.578.384 1.165.179.587.328 1.183.149.595.269 1.197.12.602.21 1.209.09.607.15 1.218.06.61.09 1.223.03.613.03 1.227v.002q0 .614-.03 1.227-.03.613-.09 1.223-.06.611-.15 1.218t-.21 1.21q-.12.601-.27 1.196-.148.596-.327 1.183-.178.587-.384 1.165-.207.578-.442 1.145-.235.567-.497 1.121-.263.555-.552 1.096-.29.542-.605 1.068t-.656 1.037q-.341.51-.707 1.003-.365.493-.755.967-.389.475-.801.93-.412.454-.846.888t-.889.846q-.454.412-.929.801-.474.39-.967.755-.493.366-1.003.707-.51.34-1.037.656-.526.316-1.068.605-.54.29-1.096.552-.554.262-1.121.497t-1.145.442q-.578.206-1.165.384-.587.179-1.183.328-.595.149-1.197.269-.602.12-1.209.21-.607.09-1.218.15-.61.06-1.223.09Q25.615 50 25 50h-.002q-.614 0-1.227-.03-.613-.03-1.223-.09-.611-.06-1.218-.15t-1.21-.21q-.601-.12-1.196-.27-.596-.148-1.183-.327-.587-.178-1.165-.384-.578-.207-1.145-.442-.567-.235-1.122-.497-.554-.263-1.095-.552-.542-.29-1.068-.605t-1.037-.656q-.51-.341-1.003-.707-.493-.365-.967-.755-.475-.389-.93-.801-.454-.412-.888-.846t-.846-.889q-.412-.454-.801-.929-.39-.474-.755-.967-.366-.493-.707-1.003-.34-.51-.656-1.037-.316-.526-.605-1.068-.29-.54-.552-1.096-.262-.554-.497-1.121t-.442-1.145q-.206-.578-.385-1.165-.178-.587-.327-1.183Q.6 30.48.48 29.878q-.12-.602-.21-1.209-.09-.607-.15-1.218-.06-.61-.09-1.223Q0 25.615 0 25v-.002q0-.614.03-1.227.03-.613.09-1.223.06-.611.15-1.218t.21-1.21q.12-.601.27-1.196.148-.596.326-1.183.179-.587.385-1.165.207-.578.442-1.145.235-.567.497-1.122.263-.554.552-1.095.29-.542.605-1.068t.656-1.037q.341-.51.707-1.003.365-.493.755-.967.389-.475.801-.93.412-.454.846-.888t.889-.846q.454-.412.929-.801.474-.39.967-.755.493-.366 1.003-.707.51-.34 1.037-.656.526-.316 1.068-.605.54-.29 1.095-.552.555-.262 1.122-.497.567-.235 1.145-.442.578-.206 1.165-.385.587-.178 1.183-.327Q19.52.6 20.122.48q.602-.12 1.209-.21.607-.09 1.218-.15.61-.06 1.223-.09Q24.385 0 25 0z" fill="#143D54"/><path d="M27.682 18.267a1.274 1.274 0 010-1.818 1.305 1.305 0 011.818 0l7.618 7.617c.236.236.382.564.382.927 0 .363-.146.69-.382.928L29.5 33.538a1.274 1.274 0 01-1.818 0 1.274 1.274 0 010-1.818l5.455-5.436H13.772a1.279 1.279 0 01-1.272-1.29c0-.709.563-1.273 1.272-1.273h19.363l-5.453-5.454z" fill="#FFF"/></g></svg>
        </WpLink>
    </div>
</template>


<script>
import WpLink from '@/components/elements/WpLink'

export default {
    name: 'venue-block',
    props: ['post'],
    components:{
        WpLink
    }

}
</script>

<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.venu-related-post{
	.inner{
		display: flex;
		text-decoration: none;
		position: relative;
		padding-bottom: 15px;
		padding-top: 15px;
		border-bottom: 2px solid $dark;
		align-items: center;
	    justify-content: space-between;
		h3{
			margin-right: 15px;
		}
		@include mquery($phone){
			padding-bottom: 8px;
			padding-top: 8px;
		}
		.tit{
			margin: 0;
		}
		&:hover{
			svg{
				.circle{
					fill: $green
				}
				path{
					fill: $dark
				}
			}
		}
		svg{
			@include mquery($phone){
				width: 30px;
				height: 30px;
			}
			.circle, path{
				transition: fill 0.2s ease-in-out;
			}
		}
	}
}
</style>